<style scoped>
.validValueCss {
  display: inline-block;
  font-family: SimSun;
  font-size: 12px;
  color: #ed3f14;
  position: relative;
  top: 6px;
  left: 69px;
}
</style>
<template>
  <div>
    <Modal v-model="isShow" :styles="{ top: '20px',width:'70%' }" @on-cancel="cancel" :mask-closable="false">
      <p slot="header">
        <span v-if="addFlag === 'add'">{{$t('logisticsProvider.addChannelInfo')}}</span>
        <span v-else-if="addFlag === 'edit'">{{$t('logisticsProvider.editChannelInfo')}}</span>
      </p>
      <Form ref="pageParams" :model="pageParams" :label-width="150" label-position="right" :rules="ruleValidate">
          <h2>{{$t('logisticsProvider.baseInformation')}}</h2>
           <div style="padding-left:20px;">
            <Row>
              <!-- 渠道名称 -->
              <Col span="10">
                <Form-item :label="$t('logisticsProvider.channelName') + '：'" prop="shippingMethodName">
                  <Input v-model.trim="pageParams.shippingMethodName"></Input>
                </Form-item>
              </Col>
              <!-- 渠道代码 -->
              <Col span="10" push="2">
                <Form-item :label="$t('logisticsProvider.channelNum') + '：'" prop="shippingMethodCode">
                  <Input v-model.trim="pageParams.shippingMethodCode"></Input>
                </Form-item>
              </Col>
            </Row>
            <Row>
              <Col span="2">
                <span class="validValueCss">*</span>
                <span style="position:relative;top:2px;left:70px;top:6px;">{{$t('common.referTime') + '：'}}</span>
              </Col>
              <!-- 参考时效 -->
              <Col span="10" pull="2">
                <Form-item>
                  <Row>
                    <Col span="8">
                      <Form-item prop="deliveryEfficiencyMin">
                        <Input v-model.trim="pageParams.deliveryEfficiencyMin"></Input>
                      </Form-item>
                    </Col>
                    <Col span="4" style="text-align:center;"><span>——</span></Col>
                    <Col span="8">
                      <Form-item prop="deliveryEfficiencyMax">
                        <Input v-model.trim="pageParams.deliveryEfficiencyMax"></Input>
                      </Form-item>
                    </Col>
                  </Row>
                </Form-item>
              </Col>
              <!-- 保险服务 -->
              <Col span="10">
                <Form-item :label="$t('common.safeServe') + '：'">
                  <RadioGroup v-model="pageParams.isInsurance">
                    <Radio :label="1">{{ $t('common.yes') }}</Radio>
                    <Radio :label="0">{{ $t('common.not') }}</Radio>
                  </RadioGroup>
                </Form-item>
              </Col>
            </Row>
            <Row>
              <Col span="2">
                <span class="validValueCss">*</span>
                <span style="position:relative;top:2px;left:70px;top:6px;">{{$t('common.sizeLimit') + '：'}}</span>
              </Col>
              <!-- 尺寸限制 -->
              <Col span="10" pull="2">
                <Form-item>
                    <Row>
                      <Col span="1"><span>{{$t('common.length')}}</span></Col>
                      <Col span="5">
                        <Form-item prop="maxSizeLength">
                          <Input v-model.trim="pageParams.maxSizeLength"></Input>
                        </Form-item>
                      </Col>
                      <Col span="2">cm</Col>
                      <Col span="1"><span>{{$t('common.width')}}</span></Col>
                      <Col span="5">
                        <Form-item prop="maxSizeWidth">
                          <Input v-model.trim="pageParams.maxSizeWidth"></Input>
                        </Form-item>
                      </Col>
                      <Col span="2">cm</Col>
                      <Col span="1"><span>{{$t('common.height')}}</span></Col>
                      <Col span="5">
                        <Form-item prop="maxSizeHeight">
                          <Input v-model.trim="pageParams.maxSizeHeight"></Input>
                        </Form-item>
                      </Col>
                      <Col span="1">cm</Col>
                    </Row>
                </Form-item>
              </Col>
              <Col span="2">
                <span class="validValueCss">*</span>
                <span style="position:relative;top:2px;left:70px;top:6px;">{{$t('common.useWeight') + '：'}}</span>
              </Col>
              <!-- 适用重量 -->
              <Col span="10" pull="2">
                <Form-item>
                  <Row>
                    <Col span="8">
                      <Form-item prop="weightRangeStart">
                        <Input v-model.trim="pageParams.weightRangeStart"></Input>
                      </Form-item>
                    </Col>
                    <Col span="1">g</Col>
                    <Col span="4" style="text-align:center;"><span>——</span></Col>
                    <Col span="8">
                      <Form-item prop="weightRangeEnd">
                        <Input v-model.trim="pageParams.weightRangeEnd"></Input>
                      </Form-item>
                    </Col>
                    <Col span="1">g</Col>
                  </Row>
                </Form-item>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <!-- 可接受包裹类型 -->
                <Form-item :label="$t('common.packageType') + '：'">
                  <CheckboxGroup v-model="extendValue1" @on-change="selectPackageChange">
                    <Checkbox label="package">{{$t('common.package')}}</Checkbox>
                    <Checkbox label="File">{{$t('common.file')}}</Checkbox>
                  </CheckboxGroup>
                </Form-item>
              </Col>
              <Col span="12">
                <!-- 接收类型 -->
                <Form-item :label="$t('common.acceptType') + '：'" prop="extendValue2">
                  <CheckboxGroup v-model="pageParams.extendValue2" @on-change="selectReceiveChange">
                    <Checkbox :label="d.value" v-for='(d, index) in productsType' :key='index'>{{d.goodsTypeName}}</Checkbox>
                  </CheckboxGroup>
                </Form-item>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <!-- 是否有跟踪号 -->
                <Form-item :label="$t('common.haveTrackNum') + '：'">
                  <RadioGroup v-model="pageParams.hasTrackingNumber">
                    <Radio :label="1">{{ $t('common.yes') }}</Radio>
                    <Radio :label="0">{{ $t('common.not') }}</Radio>
                  </RadioGroup>
                </Form-item>
              </Col>
              <Col span="10">
                <!-- 渠道类型 -->
                <Form-item :label="$t('common.channelTypes') + '：'" prop="logisType">
                  <RadioGroup v-model="pageParams.logisType">
                    <Radio :label='1'>{{ $t('common.logisType1') }}</Radio>
                    <Radio :label='2'>{{ $t('common.logisType2') }}</Radio>
                    <Radio :label='3'>{{ $t('common.logisType3') }}</Radio>
                    <Radio :label='4'>{{ $t('common.logisType4') }}</Radio>
                    <Radio :label='5'>{{ $t('common.logisType5') }}</Radio>
                  </RadioGroup>
                </Form-item>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <!-- 是否支持接口传送面单 -->
                <Form-item :label="$t('common.isPrintTemplate') + '：'">
                  <RadioGroup v-model="pageParams.isPrintTemplate">
                    <Radio :label="1">{{ $t('common.yes') }}</Radio>
                    <Radio :label="0">{{ $t('common.not') }}</Radio>
                  </RadioGroup>
                </Form-item>
              </Col>
              <Col span="10">
                <!-- 是否需要交运 -->
                <Form-item :label="$t('common.confirmRequired') + '：'">
                  <RadioGroup v-model="pageParams.confirmRequired">
                    <Radio :label="1">{{ $t('common.yes') }}</Radio>
                    <Radio :label="0">{{ $t('common.not') }}</Radio>
                  </RadioGroup>
                </Form-item>
              </Col>
            </Row>
            <Row>
              <Col span="10">
                <!-- 追踪信息查询网址 -->
                <Form-item :label="$t('common.trackUrl') + '：'" prop="trackUrl">
                  <Input v-model.trim="pageParams.trackUrl"></Input>
                </Form-item>
              </Col>
            </Row>
        </div>
        <div class="cutline"></div>
        <!-- 动态参数 -->
        <div class="canalInfo" v-if="dyParams.length">
          <h2>{{$t('common.dyParams')}}</h2>
          <div class="explain">
            <div class="paramsCont" v-for="(item, index) in dyParams" :key="index">
              <Form-item :label="item.parameterName + '：'">
                <RadioGroup v-model="dyParams[index].paramValue1" style="display:inline-block;marginLeft:20px;" v-if="item.parameterType === '01'">
                  <Radio v-for="(n, i) in item.defExtendParameterValueList" :key="i" :label="n.parameterValue">{{n.parameterValDesc}}</Radio>
                </RadioGroup>
                <CheckboxGroup v-model="dyParams[index].paramValue2" style="display:inline-block;marginLeft:20px;" v-if="item.parameterType === '02'">
                  <Checkbox v-for="(n, i) in item.defExtendParameterValueList" :key="i" :label="n.parameterValue">{{n.parameterValDesc}}</Checkbox>
                </CheckboxGroup>
                <Input v-if="item.parameterType === '03'" v-model.trim="dyParams[index].paramValue3" style="width:300px;"></Input>
              </Form-item>
            </div>
          </div>
        </div>
        <div class="cutline" v-if="dyParams.length"></div>
        <div class="canalInfo">
          <h2 style="display:inline-block;">{{$t('common.collectCity')}}</h2>
          <Button style="display:inline-block;float:right;marginRight:20px;" @click="editCity" type="primary" size="small">{{$t('common.edit')}}</Button>
          <div class="colCity">
            <div class="cityStyle" v-for="(item, index) in cloCityList" :key="index">{{item.cityName}}</div>
          </div>
        </div>
        <div class="cutline"></div>
        <!-- 计费模型 -->
        <div class="canalInfo">
          <h2 style="display:inline-block;">{{$t('logisticsProvider.chargingModel')}}</h2>
          <Button style="display:inline-block;float:right;marginRight:20px;" @click="editCharge" type="primary" size="small">{{$t('common.edit')}}</Button>
          <div class="chargExplain">
            <dTable highlight-row disabled-hover border stripe :columns="chargColumns" :data="chargData" size="small"></dTable>
          </div>
        </div>
        <div class="cutline"></div>
        <!-- 发货说明 -->
        <div class="canalInfo">
          <h2>{{$t('common.sendExplain')}}</h2>
          <Form-item>
            <Input v-model.trim="pageParams.deliverDesc" type="textarea" :autosize="{minRows: 2,maxRows: 5}" :placeholder="$t('logisticsProvider.enterShipDes')"></Input>
          </Form-item>
        </div>
      </Form>
      <!-- 揽收城市 -->
      <Modal :transfer="false" v-model="collectCity">
        <p slot="header">
          <span>{{$t('common.collectCity')}}</span>
        </p>
        <div class="province">
          {{$t('logisticsProvider.province') + "："}}
          <Select v-model="provinceParams" multiple filterable style="width:300px" @on-open-change="cityOpenChange" @on-change="provinceModalList">
            <Option v-for="(item, index) in provinceList" :value="item.stateId" :key="index">{{ item.cnName }}</Option>
          </Select>
          <Button style="marginLeft:20px;" @click="changePro" size="small">{{$t('logisticsProvider.searchCity')}}</Button>
        </div>
        <div class="city">
          {{$t('logisticsProvider.city') + "："}}
          <Select v-model="cityParams" multiple filterable style="width:300px" :label-in-value="true" @on-change="getCityModalList" @on-open-change="selectOpenChange">
            <Option v-for="(item, index) in cityList" :value="item.cityId" :key="index">{{ item.cnName }}</Option>
          </Select>
        </div>
        <div slot="footer">
            <Button type="primary" @click="addCity">{{$t('logisticsProvider.confirmAdd')}}</Button>
        </div>
      </Modal>
      <!-- 计费模型 -->
      <Modal v-model="pricingModal" v-if="pricingModelStatus" :mask-closable="false" width="1200" @on-cancel="pricingCancel">
        <p slot="header">
          <span>{{$t('logisticsProvider.chargingModel')}}</span>
        </p>
        <pricingModelOld
        ref="clearTableData"
        :isAddOrEdit="isAddOrEdit"
        :editFlag="editFlag"
        :timestamp="timestamp"
        :shipId="shipId"
        :canalFlag="canalFlag"
        @sendData="getData"
        @closeModal="closeFlag">
        </pricingModelOld>
        <div slot="footer">
          <Button @click="pricingCancel">{{$t('common.close')}}</Button>
        </div>
      </Modal>
      <div slot="footer">
        <Button @click="cancel">{{$t('common.cancel')}}</Button>
        <Button type="primary" @click="saveBtn" :loading="loading2">{{$t('common.save')}}</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
import tableMixin from '@/components/mixin/table_mixin';
import pricingModelOld from './pricingModel_old';
export default {
  props: ['canalDetailModal', 'shippingId', 'addFlag'],
  mixins: [ Mixin, tableMixin ],
  components: {
    pricingModelOld
  },
  data () {
    let self = this;
    return {
      loading2: false,
      isAddOrEdit: '',
      editFlag: false,
      canalFlag: '0', // 渠道管理计费模型标识
      shipId: null, // 渠道ID
      shippingInfoObj: null,
      isShow: false,
      pageParams: {
        deliveryEfficiencyMax: '', // 参考时效最大值
        deliveryEfficiencyMin: '', // 参考时效最小值
        isInsurance: '', // 保险服务
        maxSizeHeight: '', // 尺寸限制高
        maxSizeLength: '', // 尺寸限制长
        maxSizeWidth: '', // 尺寸限制宽
        weightRangeStart: '', // 适用重量起始值
        weightRangeEnd: '', // 适用重量截止值
        logisType: '', // 渠道类型
        shippingMethodExtendInfoId: '', // 渠道扩展信息ID
        shippingMethodName: '', // 渠道名称
        shippingMethodCode: '', // 渠道代码
        extendTypeList: [], // 渠道扩展类型（包裹类型、接收类型）
        hasTrackingNumber: '', // 是否有跟踪号
        isPrintTemplate: '', // 是否支持接口传送面单
        confirmRequired: '', // 是否需要交运
        trackUrl: '', // 追踪信息查询网址
        defExtendParamCustomList: [], // 保存的动态参数
        deliverDesc: '', // 发货说明
        pickupCityList: [], // 揽收城市
        priceModel: null, // 计费模型
        extendValue2: [] // 接收类型
      },
      // 校验
      ruleValidate: {
        shippingMethodName: [
          { required: true, message: self.t('validValue.noshipMethodName'), trigger: 'blur' }
        ],
        shippingMethodCode: [
          { required: true, message: self.t('validValue.noshipMethodCode'), trigger: 'blur' },
          { validator: self.validateMethodCode(), trigger: 'blur' }
        ],
        logisType: [
          { required: true, message: self.t('validValue.noLogisType') }
        ],
        trackUrl: [
          { validator: self.validateUrl(), trigger: 'blur' }
        ],
        deliveryEfficiencyMin: [
          // { required: true, message: self.t('validValue.noEfficiencyMin'), trigger: 'blur' },
          { validator: self.validateVal(), trigger: 'blur' }
        ],
        deliveryEfficiencyMax: [
          // { required: true, message: self.t('validValue.noEfficiencyMax'), trigger: 'blur' },
          { validator: self.validateZero(), trigger: 'blur' }
        ],
        maxSizeLength: [
          // { required: true, message: self.t('validValue.noLength'), trigger: 'blur' },
          { validator: self.validateZero(), trigger: 'blur' }
        ],
        maxSizeWidth: [
          // { required: true, message: self.t('validValue.noWidth'), trigger: 'blur' },
          { validator: self.validateZero(), trigger: 'blur' }
        ],
        maxSizeHeight: [
          // { required: true, message: self.t('validValue.noHeight'), trigger: 'blur' },
          { validator: self.validateZero(), trigger: 'blur' }
        ],
        weightRangeStart: [
          // { required: true, message: self.t('validValue.noWeightStart'), trigger: 'blur' },
          { validator: self.validateVal(), trigger: 'blur' }
        ],
        weightRangeEnd: [
          // { required: true, message: self.t('validValue.noWeightEnd'), trigger: 'blur' },
          { validator: self.validateZero(), trigger: 'blur' }
        ],
        extendValue2: [
          { required: true, type: 'array', message: self.t('validValue.noReceiveType'), trigger: 'change' }
        ]
      },
      productsType: [
        {
          value: '01',
          goodsTypeName: self.t('common.cargo')
        },
        {
          value: '02',
          goodsTypeName: self.t('common.battery')
        },
        {
          value: '03',
          goodsTypeName: self.t('common.supBattery')
        },
        {
          value: '04',
          goodsTypeName: self.t('common.liquid')
        },
        {
          value: '05',
          goodsTypeName: self.t('common.medicine')
        },
        {
          value: '06',
          goodsTypeName: self.t('common.powder')
        },
        {
          value: '07',
          goodsTypeName: self.t('common.dangerous')
        }
      ],
      extendValue1: [], // 可接受包裹类型
      dyParams: [], // 动态参数
      collectCity: false, // 揽收城市模态框
      provinceParams: [], // 省份
      provinceList: [], // 省份列表
      cityParams: [], // 城市
      cityList: [], // 城市列表
      cityModalList: [], // 城市及id
      cloCityList: [], // 展示的揽收城市
      chargColumns: [
        {
          title: self.t('common.subArea'),
          // key: 'zoneName',
          minWidth: 60,
          maxWidth: 150,
          align: 'center',
          // render: (h, params) => {
          //   if (params.row.zoneName) {
          //     return h('span', params.row.zoneName);
          //   } else {
          //     return h('span', params.index + 1 + self.t('logisticsProvider.area'));
          //   }
          // }
          render: (h, params) => {
            return h('div',
              [
                h('span', params.row.zoneName),
                h('span', self.t('logisticsProvider.area'))
              ]
            );
          }
        },
        {
          title: self.t('common.reachState'),
          key: 'reachState',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', self.setStateData(params.index, 'text'));
          }
        },
        {
          title: self.t('logisticsProvider.priceFormula'),
          key: 'formula',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            if (self.addFlag === 'add') {
              return h('div', self.setPriceData(params.index, 'text'));
            } else {
              return h('div', [
                // h('span', '运费'),
                // h('span', '='),
                h('span', params.row.formula)
              ]);
            }
          }
        }
      ],
      chargData: [], // 计费模型表格数据
      pricingModal: false,
      pricingModelStatus: false,
      timestamp: 0,
      priceVal: null,
      subVal: null,
      clickFlag: '1', // 选择城市收起标记
      provinceFlag: '2', // 省份收起标记
      resDataList: [],
      clickChargeFlag: '' // 点击编辑计费模型标识
    };
  },
  methods: {
    // 保存渠道信息校验
    saveValidFn () {
      let v = this;
      let valid = true;
      var reg = /^\d+$/;
      // 渠道名称
      if (v.pageParams.shippingMethodName === '') {
        v.$Message.info({
          content: v.t('validValue.noshipMethodName'),
          duration: 3
        });
        valid = false;
        return;
      }
      // 渠道代码
      var re = /[\u4e00-\u9fa5]/;
      let value = v.pageParams.shippingMethodCode;
      if (re.test(value) && value !== '') {
        // v.$Message.info({
        //   content: v.t('validValue.chMethodCode'),
        //   duration: 3
        // });
        // valid = false;
        // return;
      } else if (value === '') {
        v.$Message.info({
          content: v.t('validValue.noshipMethodCode'),
          duration: 3
        });
        valid = false;
        return;
      }
      // 参考时效最小值
      let minVal = v.pageParams.deliveryEfficiencyMin;
      if (minVal === '') {
        v.$Message.info({
          content: v.t('validValue.noEfficiencyMin'),
          duration: 3
        });
        valid = false;
        return;
      } else if (!reg.test(minVal) && minVal !== '') {
        v.$Message.info({
          content: v.t('validValue.isInteger'),
          duration: 3
        });
        valid = false;
        return;
      } else if (Number(minVal) < 0 && minVal !== '') {
        v.$Message.info({
          content: v.t('validValue.minTimeNoLessZero'),
          duration: 3
        });
        valid = false;
        return;
      }
      // 参考时效最大值
      let maxVal = v.pageParams.deliveryEfficiencyMax;
      if (maxVal === '') {
        v.$Message.info({
          content: v.t('validValue.noEfficiencyMax'),
          duration: 3
        });
        valid = false;
        return;
      } else if (!reg.test(maxVal) && maxVal !== '') {
        v.$Message.info({
          content: v.t('validValue.isInteger'),
          duration: 3
        });
        valid = false;
        return;
      } else if (Number(maxVal) <= 0 && maxVal !== '') {
        v.$Message.info({
          content: v.t('validValue.maxTimeNoLessOrEqualZero'),
          duration: 3
        });
        valid = false;
        return;
      }
      if (Number(minVal) >= Number(maxVal)) {
        v.$Message.info({
          content: v.t('validValue.noStartTimeMoreEndTime'),
          duration: 4
        });
        valid = false;
        return;
      }
      // 尺寸限制长
      let lengthVal = v.pageParams.maxSizeLength;
      if (lengthVal === '') {
        v.$Message.info({
          content: v.t('validValue.noLength'),
          duration: 3
        });
        valid = false;
        return;
      } else if (!reg.test(lengthVal) && lengthVal !== '') {
        v.$Message.info({
          content: v.t('validValue.isInteger'),
          duration: 3
        });
        valid = false;
        return;
      } else if (Number(lengthVal) <= 0 && lengthVal !== '') {
        v.$Message.info({
          content: v.t('validValue.lengthNoLessOrEqualZero'),
          duration: 3
        });
        valid = false;
        return;
      }
      // 尺寸限制宽
      let widthVal = v.pageParams.maxSizeWidth;
      if (widthVal === '') {
        v.$Message.info({
          content: v.t('validValue.noWidth'),
          duration: 3
        });
        valid = false;
        return;
      } else if (!reg.test(widthVal) && widthVal !== '') {
        v.$Message.info({
          content: v.t('validValue.isInteger'),
          duration: 3
        });
        valid = false;
        return;
      } else if (Number(widthVal) <= 0 && widthVal !== '') {
        v.$Message.info({
          content: v.t('validValue.widthNoLessOrEqualZero'),
          duration: 3
        });
        valid = false;
        return;
      }
      // 尺寸限制高
      let heightVal = v.pageParams.maxSizeHeight;
      if (heightVal === '') {
        v.$Message.info({
          content: v.t('validValue.noHeight'),
          duration: 3
        });
        valid = false;
        return;
      } else if (!reg.test(heightVal) && heightVal !== '') {
        v.$Message.info({
          content: v.t('validValue.isInteger'),
          duration: 3
        });
        valid = false;
        return;
      } else if (Number(heightVal) <= 0 && heightVal !== '') {
        v.$Message.info({
          content: v.t('validValue.heightNoLessOrEqualZero'),
          duration: 3
        });
        valid = false;
        return;
      }
      // 适用重量起始值
      let weightStartVal = v.pageParams.weightRangeStart;
      if (weightStartVal === '') {
        v.$Message.info({
          content: v.t('validValue.noWeightStart'),
          duration: 3
        });
        valid = false;
        return;
      } else if (!reg.test(weightStartVal) && weightStartVal !== '') {
        v.$Message.info({
          content: v.t('validValue.isInteger'),
          duration: 3
        });
        valid = false;
        return;
      } else if (Number(weightStartVal) < 0 && weightStartVal !== '') {
        v.$Message.info({
          content: v.t('validValue.startWeightNoLessZero'),
          duration: 3
        });
        valid = false;
        return;
      }
      // 适用重量截止值
      let weightEndVal = v.pageParams.weightRangeEnd;
      if (weightEndVal === '') {
        v.$Message.info({
          content: v.t('validValue.noWeightEnd'),
          duration: 3
        });
        valid = false;
        return;
      } else if (!reg.test(weightEndVal) && weightEndVal !== '') {
        v.$Message.info({
          content: v.t('validValue.isInteger'),
          duration: 3
        });
        valid = false;
        return;
      } else if (Number(weightEndVal) <= 0 && weightEndVal !== '') {
        v.$Message.info({
          content: v.t('validValue.endWeightNoLessOrEqualZero'),
          duration: 3
        });
        valid = false;
        return;
      }
      if (Number(weightStartVal) >= Number(weightEndVal)) {
        v.$Message.info({
          content: v.t('validValue.noStartMoreEnd'),
          duration: 4
        });
        valid = false;
        return;
      }
      // 接收类型
      let receiveList = v.pageParams.extendValue2;
      if (receiveList.length === 0) {
        v.$Message.info({
          content: v.t('validValue.noReceiveType'),
          duration: 3
        });
        valid = false;
        return;
      }
      // 渠道类型
      if (v.pageParams.logisType === '') {
        v.$Message.info({
          content: v.t('validValue.noLogisType'),
          duration: 3
        });
        valid = false;
        return;
      }
      // 追踪信息查询网址
      var regUrl = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\\/])+$/;
      let urlVal = v.pageParams.trackUrl;
      if (!regUrl.test(urlVal) && urlVal !== '' && urlVal !== null) {
        v.$Message.info({
          content: v.t('validValue.trackUrlError'),
          duration: 3
        });
        valid = false;
        return;
      }
      return valid;
    },
    // 渠道代码校验
    validateMethodCode () {
      let v = this;
      var reg = /[\u4e00-\u9fa5]/;
      var validateMethodCode = function (rule, value, callback) {
        if (reg.test(value) && value !== '') {
          callback(new Error(v.t('validValue.chMethodCode')));
        } else {
          callback();
        }
      };
      return validateMethodCode;
    },
    // 校验数字
    validateVal () {
      let v = this;
      var reg = /^\d+$/;
      var validateVal = function (rule, value, callback) {
        if (!reg.test(value) && value !== '') {
          callback(new Error(v.t('validValue.isInteger')));
        } else if (Number(value) < 0 && value !== '') {
          callback(new Error(v.t('validValue.noLessZero')));
        } else {
          callback();
        }
      };
      return validateVal;
    },
    // 校验是否小于等于0
    validateZero () {
      let v = this;
      var reg = /^\d+$/;
      var validateZero = function (rule, value, callback) {
        if (!reg.test(value) && value !== '') {
          callback(new Error(v.t('validValue.isInteger')));
        } else if (Number(value) <= 0 && value !== '') {
          callback(new Error(v.t('validValue.noLessOrEqualZero')));
        } else {
          callback();
        }
      };
      return validateZero;
    },
    // 追踪信息查询网址校验
    validateUrl () {
      let v = this;
      var reg = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\\/])+$/;
      // var isUrl = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
      var validateUrl = function (rule, value, callback) {
        if (!reg.test(value) && value !== '' && value !== null) {
          callback(new Error(v.t('validValue.trackUrlError')));
        } else {
          callback();
        }
      };
      return validateUrl;
    },
    // 编辑渠道详情
    getCanalDtlInfo () {
      let v = this;
      v.axios.post(api.get_shippingInfo + '?shippingMethodId=' + v.shippingId)
        .then(res => {
          if (res.data.code === 0) {
            let data = res.data.datas;
            let pos = [];
            let box = [];
            let cityList = [];
            data.extendTypeList.forEach((n, i) => { // 包裹和接收类型
              if (n.extendType === 1) {
                pos.push(n.extendValue);
                v.extendValue1 = pos;
              } else if (n.extendType === 2) {
                box.push(n.extendValue);
                v.pageParams.extendValue2 = box;
              }
            });
            data.pickupCityList.forEach((m, t) => {
              cityList.push({
                cityId: m.cityId,
                cityName: m.cityName
              });
              v.cloCityList = cityList;
            });
            v.chargData = data.priceModel !== null ? data.priceModel.priceModelZoneList : []; // 计费模型表格数据
            v.pageParams.deliveryEfficiencyMax = data.extendInfo.deliveryEfficiencyMax; // 参考时效最大值
            v.pageParams.deliveryEfficiencyMin = data.extendInfo.deliveryEfficiencyMin; // 参考时效最小值
            v.pageParams.isInsurance = data.extendInfo.isInsurance; // 保险服务
            v.pageParams.maxSizeHeight = data.extendInfo.maxSizeHeight; // 尺寸限制高
            v.pageParams.maxSizeLength = data.extendInfo.maxSizeLength; // 尺寸限制长
            v.pageParams.maxSizeWidth = data.extendInfo.maxSizeWidth; // 尺寸限制宽
            v.pageParams.weightRangeStart = data.extendInfo.weightRangeStart; // 适用重量起始值
            v.pageParams.weightRangeEnd = data.extendInfo.weightRangeEnd; // 适用重量截止值
            v.pageParams.logisType = data.extendInfo.logisType; // 渠道类型
            v.pageParams.shippingMethodExtendInfoId = data.extendInfo.shippingMethodExtendInfoId; // 渠道扩展信息ID
            v.pageParams.shippingMethodName = data.shippingMethodName; // 渠道名称
            v.pageParams.shippingMethodCode = data.shippingMethodCode; // 渠道代码
            v.pageParams.hasTrackingNumber = data.hasTrackingNumber; // 是否有跟踪号
            v.pageParams.isPrintTemplate = data.isPrintTemplate; // 是否支持接口传送面单
            v.pageParams.confirmRequired = data.confirmRequired; // 是否需要交运
            v.pageParams.trackUrl = data.trackUrl; // 追踪信息查询网址
            v.pageParams.defExtendParamCustomList = data.defExtendParamCustomList; // 保存的动态参数
            v.pageParams.deliverDesc = data.deliverDesc; // 发货说明
            v.pageParams.pickupCityList = data.pickupCityList; // 揽收城市
            v.resDataList = data.defExtendParamCustomList; // 选中的动态参数
            v.initSelectParamsFn();
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    // 获取动态参数
    getParams () {
      let v = this;
      let pos = [];
      v.axios.post(api.get_params)
        .then(res => {
          if (res.data.code === 0) {
            let data = res.data.datas;
            data.forEach((n, i) => {
              pos.push({
                parameterName: n.parameterName,
                parameterType: n.parameterType,
                parameterCode: n.parameterCode,
                defExtendParameterValueList: n.defExtendParameterValueList
              });
            });
            v.dyParams = pos;
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    // 关闭计费模型弹框
    pricingCancel () {
      let v = this;
      v.pricingModal = false;
      v.editFlag = true;
    },
    // 勾选可接收包裹类型
    selectPackageChange (data) {
      let v = this;
      v.extendValue1 = data;
    },
    // 勾选接收类型
    selectReceiveChange (data) {
      let v = this;
      v.pageParams.extendValue2 = data;
    },
    // 编辑揽收城市
    editCity () {
      let v = this;
      let pos = [];
      let box = [];
      v.collectCity = true;
      v.getProvince();
      if (v.cloCityList.length) { // 点击编辑时，加入已有的城市和省份
        v.cloCityList.forEach((n, i) => {
          pos.push(n.cityId);
          box.push(n.stateId);
        });
        let set = new Set(box);
        let newBox = Array.from(set); // 再把set转变成array
        v.cityParams = pos;
        v.provinceParams = newBox;
        console.log('省份', v.provinceParams);
        console.log('城市', v.cityParams);
        // debugger;
      }
    },
    // 获取最终的城市列表 名称及id
    getCityModalList (val) {
      let v = this;
      let pos = [];
      // v.clickFlag = '1';
      for (let i = 0; i < v.cityList.length; i++) {
        for (let t = 0; t < val.length; t++) {
          if (val[t].value === v.cityList[i].cityId) {
            pos.push(v.cityList[i]);
          }
        }
      }
      v.cityModalList = pos;
    },
    // 揽收城市模态框 确认
    addCity () {
      let v = this;
      let pos = [];
      if (!v.cityModalList.length) {
        v.$Message.info({
          content: v.t('validValue.noCitys'),
          duration: 3
        });
        v.collectCity = true;
        return false;
      }
      // debugger;
      v.cityModalList.forEach((n, i) => {
        pos.push({
          cityName: n.cnName,
          cityId: n.cityId,
          stateId: n.stateId
        });
      });
      v.cloCityList = pos;
      v.pageParams.pickupCityList = v.cloCityList;
      v.collectCity = false;
    },
    // 保存之后关闭计费模型模态框
    closeFlag (data) {
      let v = this;
      v.pricingModal = false;
      v.pageParams.priceModel = data; // 编辑传值的计费模型数据
      // 刷新计费模型表格
      v.axios.post(api.get_shippingInfo + '?shippingMethodId=' + v.shippingId)
        .then(res => {
          if (res.data.code === 0) {
            let data = res.data.datas.priceModel;
            if (data !== null) {
              v.chargData = data.priceModelZoneList; // 计费模型表格数据
            } else {
              v.chargData = [];
            }
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
      console.log(v.pageParams.priceModel);
    },
    // 新增计费模型保存
    getData (data) {
      let v = this;
      v.pageParams.priceModel = data; // 新增传值的计费模型数据
      v.pricingModal = false; // 新增保存关闭模态框
      v.chargData = data.priceModelZoneList;
      v.priceVal = data.priceType;
      v.subVal = data.subCostWay;
    },
    // 显示选中的动态参数
    initSelectParamsFn () {
      let v = this;
      for (let i = 0; i < v.dyParams.length; i++) {
        for (let t = 0; t < v.dyParams[i].defExtendParameterValueList.length; t++) {
          let out = v.dyParams[i]; // 外层
          for (let j = 0; j < v.resDataList.length; j++) {
            for (let k = 0; k < v.resDataList[j].defExtendParameterValueList.length; k++) {
              let a = v.resDataList[j]; // 外层
              let b = v.resDataList[j].defExtendParameterValueList[k]; // 内层
              if (out.parameterType === '01' && out.parameterCode === a.parameterCode) {
                out.paramValue1 = b.parameterValue;
              } else if (out.parameterType === '02') {
                for (let n = 0; n < out.paramValue2.length; n++) {
                  out.paramValue2[n] = b.parameterValue;
                }
              } else if (out.parameterType === '03' && out.parameterCode === a.parameterCode) {
                out.paramValue3 = b.parameterValue;
              }
            }
          }
        }
      }
    },
    // 数组里边对象去重
    filterDeleteArrFn (arr, name) {
      var hash = {};
      return arr.reduce(function (item, next) {
        (hash[next[name]] ? '' : hash[next[name]] = true) && item.push(next);
        return item;
      }, []);
    },
    // 保存渠道
    saveBtn () {
      let v = this;
      let pos = [];
      v.loading2 = true; // 保存加载
      // 组装参数
      // 动态参数
      for (let i = 0; i < v.dyParams.length; i++) {
        for (let t = 0; t < v.dyParams[i].defExtendParameterValueList.length; t++) {
          let out = v.dyParams[i]; // 外层
          let lining = v.dyParams[i].defExtendParameterValueList[t]; // 内层
          if (out.parameterType === '01') {
            if (out.paramValue1 === lining.parameterValue) {
              let defExtendParameterValueList = lining;
              pos.push({
                parameterType: out.parameterType,
                parameterName: out.parameterName,
                parameterCode: out.parameterCode,
                defExtendParameterValueList: [defExtendParameterValueList]
              });
            }
          } else if (out.parameterType === '02') {
            let list = [];
            for (let n = 0; n < out.paramValue2.length; n++) {
              if (out.paramValue2[n] === lining.parameterValue) {
                list.push(lining);
              }
            }
            pos.push({
              parameterType: out.parameterType,
              parameterName: out.parameterName,
              parameterCode: out.parameterCode,
              defExtendParameterValueList: list
            });
          } else if (out.parameterType === '03' && out.paramValue3 !== '') {
            let inputList = lining;
            inputList.parameterValue = out.paramValue3;
            let inputObj = inputList;
            pos.push({
              parameterType: out.parameterType,
              parameterName: out.parameterName,
              parameterCode: out.parameterCode,
              defExtendParameterValueList: [inputObj]
            });
          }
        }
      }
      let extendObj = {
        deliveryEfficiencyMax: v.pageParams.deliveryEfficiencyMax, // 参考时效最大值
        deliveryEfficiencyMin: v.pageParams.deliveryEfficiencyMin, // 参考时效最小值
        isInsurance: v.pageParams.isInsurance, // 保险服务
        maxSizeHeight: v.pageParams.maxSizeHeight, // 尺寸限制高
        maxSizeLength: v.pageParams.maxSizeLength, // 尺寸限制长
        maxSizeWidth: v.pageParams.maxSizeWidth, // 尺寸限制宽
        weightRangeStart: v.pageParams.weightRangeStart, // 适用重量起始值
        weightRangeEnd: v.pageParams.weightRangeEnd, // 适用重量截止值
        logisType: v.pageParams.logisType, // 渠道类型
        shippingMethodExtendInfoId: v.pageParams.shippingMethodExtendInfoId
        // volumeWeight: v.pageParams.volumeWeight // 材积重
      };
      if (v.extendValue1.length !== 0) {
        v.extendValue1.forEach((n, i) => {
          v.pageParams.extendTypeList.push({
            extendType: 1,
            extendValue: n
          });
        });
      }
      if (v.pageParams.extendValue2.length !== 0) {
        v.pageParams.extendValue2.forEach((m, t) => {
          v.pageParams.extendTypeList.push({
            extendType: 2,
            extendValue: m
          });
        });
      }
      // debugger;
      let objParams = {
        shippingMethodId: v.shippingId, // 渠道ID
        extendInfo: extendObj,
        shippingMethodName: v.pageParams.shippingMethodName, // 渠道名称
        shippingMethodCode: v.pageParams.shippingMethodCode, // 渠道代码
        extendTypeList: v.filterDeleteArrFn(v.pageParams.extendTypeList, 'extendValue'), // 渠道扩展类型（包裹类型、接受类型）
        hasTrackingNumber: v.pageParams.hasTrackingNumber, // 是否有跟踪号
        isPrintTemplate: v.pageParams.isPrintTemplate, // 是否支持接口传送面单
        confirmRequired: v.pageParams.confirmRequired, // 是否需要交运
        trackUrl: v.pageParams.trackUrl, // 追踪信息查询网址
        defExtendParamCustomList: pos, // 保存的动态参数
        deliverDesc: v.pageParams.deliverDesc, // 发货说明
        pickupCityList: v.pageParams.pickupCityList, // 揽收城市
        priceModel: v.pageParams.priceModel // 计费模型
      };
      if (v.saveValidFn()) {
        v.axios.post(api.add_shipping, objParams)
          .then(res => {
            if (res.data.code === 0) {
              v.loading2 = false; // 保存加载
              v.$Message.success(v.t('common.saveSuccess'));
              v.$parent.canalDetailModal = false; // 新增成功之后，关闭模态框
              v.pageParams.extendTypeList = []; // 保存成功之后,清空包裹类型和接收类型
              v.clearFormData();
              v.$parent.pageParamsStatus = true; // 保存成功之后，触发表格刷新
              if (v.clickChargeFlag === '1') {
                v.$refs.clearTableData.cachePricingData = []; // 清除分段计费模型数据
                v.$refs.clearTableData.pricingParams.volumeWeight = 0; // 清除材积重
                v.$refs.clearTableData.pricingParams.priceType = 1; // 保存之后，计费方式重置1
                v.$refs.clearTableData.pricingParams.weightType = 1; // 保存之后，计重方式重置1
                v.$refs.clearTableData.pricingParams.subCostWay = 1;
              }
              v.pageParams.pickupCityList = []; // 揽收城市清空
            } else {
              v.loading2 = false; // 保存加载
              v.$parent.canalDetailModal = true;
              v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
              v.pageParams.pickupCityList = []; // 揽收城市清空
            }
          });
      } else {
        v.loading2 = false; // 保存加载
      }
    },
    // 取消新增
    cancel () {
      let v = this;
      if (v.addFlag === 'add') {
        v.$parent.canalDetailModal = false; // 关闭模态框
        v.isShow = false;
        v.clearFormData();
        if (v.clickChargeFlag === '1') {
          v.$refs.clearTableData.cachePricingData = []; // 清除分段计费模型数据
          v.$refs.clearTableData.pricingParams.volumeWeight = 0; // 清除材积重
          v.$refs.clearTableData.pricingParams.priceType = 1; // 保存之后，计费方式重置1
          v.$refs.clearTableData.pricingParams.weightType = 1; // 保存之后，计重方式重置1
          v.$refs.clearTableData.pricingParams.subCostWay = 1;
        }
      } else {
        v.$parent.canalDetailModal = false; // 关闭模态框
        v.isShow = false;
        if (v.clickChargeFlag === '1') {
          v.$refs.clearTableData.cachePricingData = []; // 清除分段计费模型数据
          v.$refs.clearTableData.pricingParams.volumeWeight = 0; // 清除材积重
          v.$refs.clearTableData.pricingParams.priceType = 1; // 保存之后，计费方式重置1
          v.$refs.clearTableData.pricingParams.weightType = 1; // 保存之后，计重方式重置1
          v.$refs.clearTableData.pricingParams.subCostWay = 1;
        }
      }
    },
    // 获取省份
    getProvince () {
      let v = this;
      v.axios.get(api.get_province)
        .then(res => {
          if (res.data.code === 0) {
            v.provinceList = res.data.datas;
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    // 根据已选省份查询城市
    changePro () {
      let v = this;
      v.axios.get(api.get_city + '?stateIds=' + v.provinceParams)
        .then(res => {
          if (res.data.code === 0) {
            v.cityList = res.data.datas;
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
      // if (v.cloCityList.length) { // 添加已有的
      //   v.cloCityList.forEach((n, i) => {
      //     v.cityParams.push(n.cityId);
      //   })
      // }
    },
    provinceModalList () {
      // this.provinceFlag === '2';
      // console.log(this.provinceFlag);
    },
    // 省份下拉框收起时触发
    cityOpenChange (bool) {
      let v = this;
      if (bool === false && v.provinceFlag === '2') {
        v.changePro();
      }
    },
    // 城市下拉框展开或收起时触发
    selectOpenChange (bool) {
      let v = this;
      if (bool === false && v.clickFlag === '1') {
        v.collectCity = false;
        v.addCity();
      }
      // debugger;
    },
    // 编辑计费模型
    editCharge () {
      let v = this;
      let date = new Date().getTime();
      v.timestamp = date;
      v.pricingModelStatus = true;
      v.$nextTick(function () {
        v.pricingModal = true;
        v.editFlag = false;
        v.isAddOrEdit = v.addFlag;
        v.clickChargeFlag = '1';
      });
    },
    // 整理国家数据
    setStateData (index, type) {
      let v = this;
      for (let i = 0; i < v.chargData.length; i++) {
        if (i === index) {
          let stateNameArr = [];
          let item = v.chargData[index].priceModelCountryList;
          for (let t = 0; t < item.length; t++) {
            let subItem = item[t];
            if (subItem.cnName !== null && subItem.cnName !== '' && subItem.cnName !== undefined) {
              stateNameArr.push(subItem.cnName);
            }
            if (t === item.length - 1 && type === 'text') {
              return stateNameArr.toString();
            }
          }
        }
      }
    },
    // 设置计费公式
    setPriceData (index, type) {
      let v = this;
      for (let i = 0; i < v.chargData.length; i++) {
        if (i === index) {
          if (v.priceVal === 1) {
            let arr = '运费' + '=' + '(' + '重量' + '*' + v.chargData[index].price + '+' + v.chargData[index].registrationFee + '+' + v.chargData[index].operatingCost + ')' + '*' + '(' + '1' + '+' + v.chargData[index].additionalFeeRate + ')';
            if (type === 'text') {
              return arr;
            }
          } else if (v.priceVal === 2) {
            let arr = '运费' + '=' + '{' + v.chargData[index].firstWeightPrice + '+' + '(' + '包裹重量' + '-' + v.chargData[index].firstWeight + ')' + '/' +
            v.chargData[index].unitWeight + '*' + v.chargData[index].unitWeightPrice + '+' + v.chargData[index].registrationFee + '+' + v.chargData[index].operatingCost + '}' + '*' + '(' + '1' + '+' + v.chargData[index].additionalFeeRate + ')';
            if (type === 'text') {
              return arr;
            }
          } else if (v.priceVal === 3 && v.subVal === 1) {
            let arr = '运费' + '=' + '(' + '重量' + '*' + '单价' + '+' + '挂号费' + '+' + '操作费' + ')' + '*' + '(' + '1' + '+' + '附加费' + ')';
            if (type === 'text') {
              return arr;
            }
          } else if (v.priceVal === 3 && v.subVal === 2) {
            let arr = '运费' + '=' + '(' + '单价' + '+' + '挂号费' + '+' + '操作费' + ')' + '*' + '(' + '1' + '+' + '附加费' + ')';
            if (type === 'text') {
              return arr;
            }
          } else if (v.priceVal === 3 && v.subVal === 3) {
            let arr = '运费' + '=' + '{' + '首重费用' + '+' + '(' + '包裹重量' + '-' + '首重' + ')' + '/' + '续重单位重量' + '*' + '单价' + '+' + '挂号费' + '+' + '操作费' + '}' + '*' + '(' + '1' + '+' + '附加费' + ')';
            if (type === 'text') {
              return arr;
            }
          }
        }
      }
    },
    // 清空表单数据
    clearFormData () {
      let v = this;
      v.chargData = []; // 计费模型表格
      v.extendValue1 = []; // 可接受包裹类型
      v.pageParams.extendValue2 = []; // 接收类型
      v.pageParams.deliveryEfficiencyMax = ''; // 参考时效最大值
      v.pageParams.deliveryEfficiencyMin = ''; // 参考时效最小值
      v.pageParams.isInsurance = ''; // 保险服务
      v.pageParams.maxSizeHeight = ''; // 尺寸限制高
      v.pageParams.maxSizeLength = ''; // 尺寸限制长
      v.pageParams.maxSizeWidth = ''; // 尺寸限制宽
      v.pageParams.weightRangeStart = ''; // 适用重量起始值
      v.pageParams.weightRangeEnd = ''; // 适用重量截止值
      v.pageParams.logisType = ''; // 渠道类型
      v.pageParams.shippingMethodName = ''; // 渠道名称
      v.pageParams.shippingMethodCode = ''; // 渠道代码
      v.pageParams.hasTrackingNumber = ''; // 是否有跟踪号
      v.pageParams.isPrintTemplate = ''; // 是否支持接口传送面单
      v.pageParams.confirmRequired = ''; // 是否需要交运
      v.pageParams.trackUrl = ''; // 追踪信息查询网址
      v.pageParams.deliverDesc = ''; // 发货说明
      v.cloCityList = []; // 揽收城市
      v.provinceParams = []; // 省份
      v.cityParams = []; // 城市
    }
  },
  watch: {
    canalDetailModal (n) {
      this.isShow = n;
      if (n) {
        this.getParams(); // 动态参数
        // console.log(this.shippingId);
        if (this.shippingId) {
          this.shipId = this.shippingId; // 渠道ID
          this.getCanalDtlInfo(); // 编辑渠道信息
        } else {
          this.shipId = null;
        }
      }
    },
    'addFlag': function (val) {
      if (val === 'add') {
        this.clearFormData();
      }
      // debugger;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/logisticsProvider/components/logisticsProvider/channelManagementDetail_old.vue